/**
 * ID comparison and normalization utilities
 * 
 * Handles the reality that our system has multiple ID formats:
 * - Django: numeric IDs (123)
 * - Fulcrum: UUID strings ("ee123955-7b1e-491d-87f1-b3a2e25b9b69")
 * - GeoJSON: string representations of IDs ("123")
 */

/**
 * Compare two IDs regardless of their type (string vs number)
 * 
 * @param id1 - First ID to compare
 * @param id2 - Second ID to compare
 * @returns true if IDs represent the same entity
 * 
 * @example
 * idsEqual('123', 123)     // → true
 * idsEqual('22', 22)       // → true  
 * idsEqual('uuid-123', 'uuid-123') // → true
 * idsEqual(null, undefined) // → false
 */
export function idsEqual(id1: string | number | null | undefined, id2: string | number | null | undefined): boolean {
  // Handle null/undefined cases
  if (id1 == null || id2 == null) {
    return id1 === id2;
  }
  
  // Convert both to strings for comparison
  return String(id1) === String(id2);
}

